import React from "react";
//#region types
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import { TransactionCorrespondentProps } from "models/propTypes/accountingPropTypes";
//#endregion
//#region components
import { Profiles } from "components/common";
//#endregion

const TransactionCorrespondent: React.FC<TransactionCorrespondentProps> = (props) => {
  const { type } = props;

  return type === WintSuperkollAPIModelAccounting.VoucherType.IncomingInvoice ? (
    <Profiles.SupplierProfileLink id={props.id} name={props.name} />
  ) : type === WintSuperkollAPIModelAccounting.VoucherType.Invoice ? (
    <Profiles.CustomerProfileLink id={props.id} name={props.name} />
  ) : (
    <></>
  );
};

export default TransactionCorrespondent;
